/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, type ReactElement, createContext, forwardRef } from 'react';
import { type ContextValue, TableBody as TableBodyCore, type TableBodyProps as TableBodyCoreProps, useContextProps } from 'react-aria-components';
import { $ } from '../../tokens.stylex';


interface TableBodyProps<T> extends Omit<TableBodyCoreProps<T>, 'style' | 'className' | 'renderEmptyState'> {
  style?: stylex.StyleXStyles;
}

const TableBodyContext = createContext<ContextValue<TableBodyProps<object>, HTMLDivElement>>({});

const TableBody = forwardRef((props: TableBodyProps<object>, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, TableBodyContext);

  const { style, children, ...coreProps } = props;

  return (
    <TableBodyCore
      ref={ref}
      {...stylex.props(styles.base, style)}
      {...coreProps}>
      {children}
    </TableBodyCore>
  );
}) as <T>(p: TableBodyProps<T> & { ref?: ForwardedRef<HTMLTableSectionElement> }) => ReactElement;

const styles = stylex.create({
  base: {
    // eslint-disable-next-line @stylexjs/valid-styles
    ':not(#__unused__) > :nth-child(even) [role="gridcell"]': {
      backgroundImage: $.tableRowBgAlternating,
    },
    // Currently, there is no other way to style even rows. RAC does not disclose the row index
    // eslint-disable-next-line @stylexjs/valid-styles
    ':not(#__unused__) > :nth-child(even) [role="rowheader"]': {
      backgroundImage: $.tableRowBgAlternating,
    },
  },
});

export { TableBody, TableBodyContext, type TableBodyProps };
